import { cn } from '@gto/ui/cn'
import { useMediaQuery } from '@gto/ui/hooks/use-media-query'

import { useAuth } from '@/hooks/use-auth'
import { CryptoRedemptions } from '@/pages/rewards/components/crypto-redemptions'
import { EmailVerificationForm } from '@/pages/rewards/components/email-verification-form'
import { GtoSubscriptionsSection } from '@/pages/rewards/components/gto-subscriptions-section'
import { RewardsPageHeader } from '@/pages/rewards/components/rewards-page-header'

export const EdgeRoute = () => {
  const isSmAndLower = useMediaQuery('down', 'sm')
  const { emailValidated } = useAuth()

  return (
    <div className={cn('flex flex-col', isSmAndLower ? 'gap-8' : 'gap-14')}>
      <RewardsPageHeader />
      {emailValidated ? (
        <>
          <GtoSubscriptionsSection />
          <CryptoRedemptions />
        </>
      ) : (
        <EmailVerificationForm />
      )}
    </div>
  )
}
